import { createGlobalStyle } from 'styled-components';

import { isDigitalQuoteDomain } from 'utils/siteUtils';

const progressBarColor = isDigitalQuoteDomain() ? '#29d' : '#ff771a';

export const GlobalStyle = createGlobalStyle`
  .ant-calendar-footer {
    padding: 10px 0;
  }

  .ant-cascader-menus.ant-cascader-menus  {
    z-index: 1500
  }

  .ant-cascader-menu {
    height: 100%;
    max-height: 250px;
    width: unset !important;
  }

  .ant-calendar-range-quick-selector {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    text-align: left;
    width: 100%;

    span {
      background-color: #fff;
      border: 1px solid currentColor;
      border-radius: 0;
      color:  #108ee9;
      cursor: pointer;
      display: block;
      margin: 5px;
      padding: 10px;
      text-align: center;
      width: 45%;

      &:hover {
        background-color: #e6f7ff;
        border-color: currentColor;
        color: #49a9ee;
      }
    }
  }

  .ant-calendar-time-picker-btn {
    text-transform: capitalize;
  }

  .ant-calendar-ok-btn, .ant-calendar-ok-btn-disabled {
    text-transform: uppercase;
  }

  .ant-picker-input {
    height: 100%;
  }

  .common-ant-picker {
    &.suggestions-accepted {
      input {
        color: var(--chakra-colors-interaction-suggestion);
      }
    }
    .ant-picker-suffix {
      display: flex;
      align-items: center;
      position:relative;
    }

    .ant-picker-clear {
      z-index: 1;
      right: 2px;
    }
  }

  .ant-picker-footer-extra {
    padding: 0;
    line-height: 0;
  }

  .ant-tooltip {
    z-index: var(--chakra-zIndices-tooltip);
  }

  .antd-datepicker-channel-access-modal {
    z-index: var(--chakra-zIndices-tooltip);
  }

  #nprogress .bar {
    background: ${progressBarColor};
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }

  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px ${progressBarColor}, 0 0 5px ${progressBarColor};
    opacity: 1.0;
    transform: rotate(3deg) translate(0px, -4px);
  }

  body {
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    @media print {
      position: unset;
    }
  }
`;
